"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (overloads) {
    for (var _len = arguments.length, innerArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        innerArgs[_key - 1] = arguments[_key];
    }

    return function () {
        var fn = overloads["" + arguments.length];
        if (!fn) {
            throw new Error("Function must be given this many arguments: " + Object.keys(overloads).join(", "));
        }
        return fn.apply(undefined, _toConsumableArray(innerArgs)).apply(undefined, arguments);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/util/overload.js
// module id = 396
// module chunks = 35783957827783